import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "PuntajePage",
    data() {
        let ss = new MainService();
        return {
            msg: "PuntajePage",
            ss: ss,
            ajax: {
                "url": ss.indexPuntaje(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Puntaje', name: 'Puntaje', title: 'Puntaje' },
                { data: 'CriterioPuntaje', name: 'CriterioPuntaje', title: 'CriterioPuntaje' },
                { data: 'PersonaDefensa', name: 'PersonaDefensa', title: 'PersonaDefensa' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            puntajes: [],
            puntaje: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newPuntaje() {
            this.puntaje = {};
            this.$refs['frm-puntaje'].show();
        },
        showPuntaje(id) {
            this.isLoading=true;
            this.ss.showPuntaje(id).then(
                (result) => {
                    let response = result.data;
                    this.puntaje = response.data;
                    this.$refs['view-puntaje'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editPuntaje() {
            this.$refs['frm-puntaje'].show();
            this.$refs['view-puntaje'].hide();
        },
        cancelPuntaje() {
            if (this.puntaje.id) {
                this.$refs['view-puntaje'].show();
            }
            this.$refs['frm-puntaje'].hide();
        },
        savePuntaje() {
            this.ss.storePuntaje(this.puntaje).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-puntaje'].hide();
                    this.$refs['datatable-puntaje'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deletePuntaje() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyPuntaje(this.puntaje)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-puntaje'].hide();
                                this.$refs['datatable-puntaje'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Puntaje').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showPuntaje(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
